import { useAppStore } from "@hooks/useAppStore";
import { useAppTemplate } from "@hooks/useAppTemplate";
import type { Distribution } from "@memorang/types";
import { useAppTheme } from "@memorang/ui/useAppTheme";
import {
	getCompletionProgress,
	getMasteryProgressData,
	getProgressColorScale,
} from "./useHomeHeader/helpers";

export const useDonutProgress = (distribution: Distribution) => {
	const theme = useAppTheme();
	const { isLanguageLearningApp } = useAppTemplate();
	const showPointsBasedScore = useAppStore(
		(state) => state.reportView?.formative?.showPointsBasedScore,
	);
	const sortedMasteryLevels = useAppStore(
		(state) => state.app.masteryLevels,
	)?.sort((a, b) => a.sortOrder - b.sortOrder);

	const donutProgressData = isLanguageLearningApp
		? getCompletionProgress(distribution)
		: showPointsBasedScore
			? getMasteryProgressData(distribution, sortedMasteryLevels!)
			: undefined;
	const donutProgressColorScale = isLanguageLearningApp
		? [theme.colors.primary, theme.palette.progress.none]
		: showPointsBasedScore
			? getProgressColorScale(theme, sortedMasteryLevels!)
			: undefined;

	return { donutProgressData, donutProgressColorScale };
};
